export const palette = {
  /* Accessible primary color */
  primary: '#198073',
  // Darker version - for tags, tabs, or anything against a light green background
  primarySelected: '#14665C',
  secondary: '#7700EE',
  tertiary: '#F2994A',
  tertiarySelected: '#915c2c',
  brightgreen: '#11D200',
  red: '#ba1a1a',
  midnight: '#141414',
  carbon: '#666666',
  darkgray: '#4D4D4D',
  gray: '#BBBBBB',
  mediumgray: '#E0E0E0',
  lightgray: '#F2F2F2',
  limelite: '#F9FBFB',
  eggshell: '#FAFAFA',
  whitesmoke: '#EEF2F7',
  white: '#FFFFFF',
  black: '#000000',
}

export type Color = keyof typeof palette
